import { Trans } from "react-i18next";
import { Field } from "formik";
import PropTypes from "prop-types";

const TextArea = ({
  id,
  name,
  label,
  cols,
  rows = 3,
  placeholder,
  optional,
}) => {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm">
        <span className="font-semibold">{label}</span>
        {optional && (
          <span>
            &nbsp;&#40;
            <Trans>optional</Trans>
            &#41;
          </span>
        )}
      </label>
      <Field
        as="textarea"
        id={id}
        name={name}
        cols={cols}
        rows={rows}
        placeholder={placeholder}
        className="w-full resize-none rounded-md border px-3 py-2 text-sm"
      />
    </div>
  );
};

TextArea.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  cols: PropTypes.number,
  rows: PropTypes.number,
  placeholder: PropTypes.string,
  optional: PropTypes.bool,
};

export default TextArea;
